// src/components/Card.js
import React, { forwardRef } from "react";

const Card = forwardRef(({ children, className = "", variant = "default" }, ref) => {
  const variantClasses = {
    default: "bg-theme-card-solid border border-border",
    glass: "bg-theme-card backdrop-blur-sm border border-border",
    elevated: "bg-theme-card-solid border border-border shadow-theme-lg",
  };

  return (
    <div
      ref={ref}
      className={`
        rounded-xl p-4 transition-shadow duration-200 ease-out
        hover:shadow-md hover:border-border-hover
        ${variantClasses[variant] || variantClasses.default}
        ${className}
      `}
    >
      {children}
    </div>
  );
});

Card.displayName = "Card";

export default Card;
